import { request } from "../lib/http";

export function fetchAll() {
  return request({
    url: "financial/frequency",
    method: "get",
  });
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `financial/frequency`,
    method: "get",
    params: queriesParams,
  });
}

export function show(id) {
  return request({
    url: `financial/frequency/${id}`,
    method: "get",
  });
}

export function add(data) {
  return request({
    url: "financial/frequency",
    method: "post",
    data,
  });
}

export function edit(id, data) {
  return request({
    url: `financial/frequency/${id}`,
    method: "patch",
    data,
  });
}
